import { render, staticRenderFns } from "./ContractCopyCof.vue?vue&type=template&id=53ff6ca6&scoped=true&"
import script from "./ContractCopyCof.vue?vue&type=script&lang=js&"
export * from "./ContractCopyCof.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=53ff6ca6&lang=less&scoped=true&"
import style1 from "./ContractCopyCof.vue?vue&type=style&index=1&id=53ff6ca6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff6ca6",
  null
  
)

export default component.exports